/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ListOrderBills_1$Params {
  EmployeeId?: string;
  VenueId?: string;
  Filter?: string;
  Date?: string;
  PageSize?: number;
  PageNumber?: number;
}

export function listOrderBills_1(http: HttpClient, rootUrl: string, params?: ListOrderBills_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, listOrderBills_1.PATH, 'get');
  if (params) {
    rb.query('EmployeeId', params.EmployeeId, {});
    rb.query('VenueId', params.VenueId, {});
    rb.query('Filter', params.Filter, {});
    rb.query('Date', params.Date, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('PageNumber', params.PageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

listOrderBills_1.PATH = '/api/mng/OrderBill/listorderbills';
